import { UserPermissions } from './Permission';

export interface AIInstruction {
    label: string;
    instruction: string;
}

export class Session {
    user_id: number = 0;
    name: string = '';
    email: string = '';
    full_name: string = '';
    origin: string = '';
    domainName: string = '';
    ai_agent_config!: {
        agent_id?: string;
        domain_id: number;
        flow: {
            url: string;
        };
        folders: Record<'scripts' | 'css' | 'knowledge' | 'documents' | 'documentsv2' | 'analyze_images' | 'speech', string>;
        file_types: string[];
        chat?: {
            sbx_ai_bot_options?: {
                input?: AIInstruction[];
                agent_to_bot?: AIInstruction[];
            };
        };
        text_url: {
            web: boolean;
            video: boolean;
            audio: boolean;
        };
        path_avatars: string;
        folder_key_avatars: string;
        assesors: {
            label: string;
            value: string;
        }[];
        agent_dashboard_params?: { [key: string]: string[] };
        agent_setup: {
            models: {
                value: string;
                label: string;
            }[];
        };
    };
    countries: Country[] = [];
    routes: View[] = [];
    logo: string = '';
    defaultLocale: string = '';
    languages: Record<string, Record<string, Record<string, string>>> = {};
    permissions: Record<string, string> = {};
    isAdmin: boolean = false;
    permissions_list: UserPermissions[] = [];
    user_key: string = '';
    extra_setup!: {
        session: {
            activity_timeout: ConfigInactivity[];
        };
    };
    constructor() {}
}

export interface View {
    path: string;
    name: string;
    root: string;
    icon?: string;
    permission: string | string[];
    views?: View[];
}

export interface ConfigInactivity {
    section_app: 'ai-studio' | 'all';
    time: number;
    enable: boolean;
}

export interface Country {
    code: string;
    country: string;
    flag: string;
    name: string;
}
